import { useEffect } from 'react'

/**
 * Zet de titel van het tabblad, precies zoals hij hier staat.
 *
 * Zonder dit stond er overal "Confetti" en zag je met vijf tabbladen open niet
 * meer welk scherm waar zat.
 *
 * Er wordt bij het opruimen niets teruggezet. Dat zou de titel tussen twee
 * pagina's door laten terugvallen, wat je als een flikkering in je tabblad
 * ziet. Elke route zet zijn eigen titel, dus de volgende schrijft hem over — en
 * routes die dat niet doen zijn er niet; zie App.tsx.
 */
export function useDocumentTitle(title: string): void {
  useEffect(() => {
    document.title = title
  }, [title])
}
